import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createVNode("span", null, "We're sorry, you don't have access to this page"),
  /*#__PURE__*/_createVNode("div", { class: "text-body--xs" }, "Contact the admin if you think It's an error")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")

  return (_openBlock(), _createBlock(_component_Error, {
    code: 403,
    title: "Access denied"
  }, {
    body: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}